<div class="flex items-center relative w-[344px] h-[339px] sm:w-[599px] sm:h-[591px] no-scrollbar">
  <div
    class="flex overflow-scroll items-center justify-center w-[344px] h-[339px] sm:w-[599px] sm:h-[591px] no-scrollbar"
    (mouseleave)="onMouseLeave()"
    (mouseup)="onMouseUp($event)"
    lnHorizontalSwipe (swipeToLeft)="NextImage()" (swipeToRight)="PrevImage()"
    #imageScrollContainer
  >
    <img
      #mainImage
      (mousemove)="onPointerHover($event)"
      [src]="activosDigitales[selectedImageIndex].urlImg"
      class="transition-transform duration-300 hover:cursor-zoom-in w-[344px] h-[339px] sm:w-[599px] sm:h-[591px] object-cover flex-none"
      alt=""
      [style.transform]="transformStyle"
      (mousedown)="onMouseDown($event)"
      (contextmenu)="$event.preventDefault()"
      (mouseup)="onMouseUp($event)"
      (load)="UpdateMainImageSize()"
    />
  </div>

  @if(zoomLevel === 1 && activosDigitales.length > 1) {
  <button
    (click)="PrevImage()"
    class="rounded-full bg-white hover:bg-[#F2F2F2] absolute left-0 translate-x-1/2 cursor-pointer"
  >
    <ln-chevron-left-svg-icon [class]="'w-8 h-8'"></ln-chevron-left-svg-icon>
  </button>
  <button
    (click)="NextImage()"
    class="rounded-full bg-white hover:bg-[#F2F2F2] absolute right-0 -translate-x-1/2 cursor-pointer"
  >
    <ln-chevron-right-svg-icon [class]="'w-8 h-8'"></ln-chevron-right-svg-icon>
  </button>
  }
</div>
